// USA
export const locale = {
  GLOBAL: {
    Title: "Payamak land",
    PostalCode: "Postal Code",
    postalCodes: "postal codes",
    selectedPostalCodes: "selected postal codes",
    MciNumberCount: "Mci Count",
    MtuNumberCount: "Mtu Count",
    TotalCount: "Total Count",
    Coefficient: "Coefficient",
    Back: "Back"
  },
  ERRORS: {
    PhoneIsNotValid: "Phone Number is Not valid.",
    InvalidNumber: "تعداد وارد شده صحیح نمیباشد",
    NoSelectedLineNumber: "Please Select Line Number.",
    EmptyText: "Please Fill input.",
    UnknownError: "َUnknown Error",
    TryAgain: "Please Try Again Later",
    NoAccountCharge: "No Balance",
    NoAccess: "Access Denied",
    PleasebyeAPlane: "Please buy a Plane.",
    PleaseChargeYourAccount: "Please Charge Your Account.",
    AccessDenied: "Access Denied",
    AccessDeniedDescription: "Please call to admin",
    Error: "Error",
    InvalidText: "InvalidText",
    InvalidTextContainsLink: "You can't use link in text"
  },
  INFOS: {
    SuccessSentSms: "Success sent Sms",
    SmsRequestInQueue: "Your Request Process After Accept Admin.",
    SendData: "Send Info",
    CheckData: "check bellow data"
  },
  FORMS: {
    DestinationPhone: "To Number",
    TestDestinationPhone: "Test Phone Number",
    SourceNumber: "From Number",
    Text: "Text",
    CharCount: "Char Count",
    FarsiCharCount: "Farsi Char Count",
    EnglishCharCount: "English Char Count",
    Send: "Send",
    SendTime: "Send Time",
    SendTest: "Send a Test",
    SendToTestNumber: "Send To Test Number",
    SmsCount: "Sms Count",
    SmsLang: "Sms Language",
    Add: "add",
    FromFile: "From File",
    TestNumber: "Test Number",
    Test: "Test",
    ServiceRelated: "Service Related",
    Price: "price",
    NumbersCount: "Count of Numbers :",
    NumbersCountToSend: "Count of Numbers Sent to it",
    Search: "Search",
    Title: "title",
    RequestTime: "Request Time",
    RequestInformation: "Request Information",
    CreateNewPhoneBook: "Create a Phone book"
  },
  BUTTONS: {
    OK: "Ok",
    AccountCharge: "Account Charge",
    Reports: "Reports",
    RemoveAll: "Remove All",
    BuyAPlane: "خرید پلن",
    Accept: "تایید",
    Reject: "رد کردن",
    Yes: "Yes",
    No: "No",
    Create: "ایجاد",
    New: "جدید",
    Save: "ذخیره",
    Delete: "delete",
    More: "more",
    TryAgain: "Try Again",
    Close: "close"
  },
  DIALOGS: {
    Waiting: "Please Wait",
    RejectItQuestion: "Reject it?",
    AcceptItQuestion: "Accept it?",
    Rejected: "Rejected",
    Accepted: "Accepted",
    Error: "Error",
  },
  TOBE: {
    to: "to",
    from: "from",
  },
  CONFIRM: {
    DeleteA: "Do you want to remove {a} ?",
    DeleteALL: "Do you want to remove all ?",
    Delete: "Do you want to remove ?",
    Edit: "Do you want to edit ?",
    EditA: "Do you want to edit {a} ?"
  },
  LANGUAGE: {
    English: "English",
    Persian: "Farsi"
  },
  LISTS: {
    NoData: "No Data",
    NoDataFound: "No Data Found",
    NoDataFoundFor: "No Data Found For {a}",
    NoPhoneNumber: "No Phone Number",
    AddANumber: "Add A Number",
    NoPostalCode: "No Postal Code",
    City: "city"
  },
  PAGES: {
    SendSms: "Send Sms",
    MapSms: "Send By Map",
    SendToCity: "Send To City",
    AddedBefore: "Added Before",
    PhoneBook: "Phone Book"
  },
  MONETARY: {
    Rial: "Rial"
  },
  HINTS: {
    SendMessageTitle: "The title is a custom name that you can use the title of the previously sent messages to write the text of the message in the text section. The title is not sent in the message. The title is used for the reporting section and message suggestions.",
    SendMessageTime: "زمان ارسال زمانی است که پیامک شما در صف ارسال قرار گرفته میشود. ت.جه داشته باشید که در صورت تایید نشدن توسط ادمین پیامک ارسال نمیشود.",
    CreatePhoneBook: "This name will be used to add to phonebook"
  },
  TOASTS: {
    SuccessCreate: "Created",
    FailedCreated: "Failed to create",
    SuccessDelete: "Deleted",
    FailedDelete: "Failed to Delete",
    SuccessEdit: "Edited",
    FailedEdit: "Failed to Edit",
    AddedSuccess: "Added",
    AddedFailed: "Faild to Add"
  },
  WALLET: {
    CustomCharge: "CustomPrice",
    GateWay: "GateWay",
    Price: "Price",
    Details: [
      "٩٪؜ ماليات به مبلغ وارد شده اضافه خواهد شد.",
      "لطفا در درج مبلغ دقت لازم را مبذول فرمایید، مبلغ واریزی به هیچ عنوان قابل استرداد نمی باشد."
    ],
    noGateWay: "درگاهی برای شما تعریف نشده است.",
    PriceNotInRange: "input price most between {min} and {max}.",
    Pay: "Pay",
    ErrorOnRedirectToGateWay: "Error on Redirect To GateWay",
    ChargeWalletButtonDescription: "press + to charge your account",
  },


  TRANSLATOR: {
    SELECT: "Select your language"
  },
  MENU: {
    NEW: "new",
    ACTIONS: "Actions",
    CREATE_POST: "Create New Post",
    PAGES: "Pages",
    FEATURES: "Features",
    APPS: "Apps",
    DASHBOARD: "Dashboard"
  },
  AUTH: {
    GENERAL: {
      OR: "Or",
      SUBMIT_BUTTON: "Submit",
      NO_ACCOUNT: "Don't have an account?",
      SIGNUP_BUTTON: "Sign Up",
      FORGOT_BUTTON: "Forgot Password",
      BACK_BUTTON: "Back",
      PRIVACY: "Privacy",
      LEGAL: "Legal",
      CONTACT: "Contact"
    },
    LOGIN: {
      TITLE: "Login Account",
      BUTTON: "Sign In"
    },
    FORGOT: {
      TITLE: "Forgot Password?",
      DESC: "Enter your email to reset your password",
      SUCCESS: "Your account has been successfully reset."
    },
    REGISTER: {
      TITLE: "Sign Up",
      DESC: "Enter your details to create your account",
      SUCCESS: "Your account has been successfuly registered."
    },
    INPUT: {
      EMAIL: "Email",
      FULLNAME: "Fullname",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
      USERNAME: "Username"
    },
    VALIDATION: {
      INVALID: "{{name}} is not valid",
      REQUIRED: "{{name}} is required",
      MIN_LENGTH: "{{name}} minimum length is {{min}}",
      AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
      NOT_FOUND: "The requested {{name}} is not found",
      INVALID_LOGIN: "The login detail is incorrect",
      REQUIRED_FIELD: "Required field",
      MIN_LENGTH_FIELD: "Minimum field length:",
      MAX_LENGTH_FIELD: "Maximum field length:",
      INVALID_FIELD: "Field is not valid"
    }
  },
  ECOMMERCE: {
    COMMON: {
      SELECTED_RECORDS_COUNT: "Selected records count: ",
      ALL: "All",
      SUSPENDED: "Suspended",
      ACTIVE: "Active",
      FILTER: "Filter",
      BY_STATUS: "by Status",
      BY_TYPE: "by Type",
      BUSINESS: "Business",
      INDIVIDUAL: "Individual",
      SEARCH: "Search",
      IN_ALL_FIELDS: "in all fields"
    },
    ECOMMERCE: "eCommerce",
    CUSTOMERS: {
      CUSTOMERS: "Customers",
      CUSTOMERS_LIST: "Customers list",
      NEW_CUSTOMER: "New Customer",
      DELETE_CUSTOMER_SIMPLE: {
        TITLE: "Customer Delete",
        DESCRIPTION: "Are you sure to permanently delete this customer?",
        WAIT_DESCRIPTION: "Customer is deleting...",
        MESSAGE: "Customer has been deleted"
      },
      DELETE_CUSTOMER_MULTY: {
        TITLE: "Customers Delete",
        DESCRIPTION: "Are you sure to permanently delete selected customers?",
        WAIT_DESCRIPTION: "Customers are deleting...",
        MESSAGE: "Selected customers have been deleted"
      },
      UPDATE_STATUS: {
        TITLE: "Status has been updated for selected customers",
        MESSAGE: "Selected customers status have successfully been updated"
      },
      EDIT: {
        UPDATE_MESSAGE: "Customer has been updated",
        ADD_MESSAGE: "Customer has been created"
      }
    }
  }
};
